import { useProfile } from '../profile'
import { useGetAccountantQuery } from './api'

export const useAccountant = () => {
    const { accountantId } = useProfile()

    const {
        data: accountant,
        isFetching,
        isSuccess,
    } = useGetAccountantQuery({ id: accountantId }, { skip: !accountantId })

    const accountantFirstName = accountant?.firstName || 'Tu asesor'
    const accountantFullName =
        `${accountant?.firstName || ''} ${String(accountant?.lastName || '')}`.trim() || 'Tu asesor'

    return { accountant, accountantFirstName, accountantFullName, isSuccess, isFetching }
}
